import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged, switchMap } from 'rxjs/operators';
var startTime = Date.now();
export var MenuOrientation;
(function (MenuOrientation) {
    MenuOrientation["LANDSCAPE"] = "LANDSCAPE";
    MenuOrientation["PORTRAIT"] = "PORTRAIT";
})(MenuOrientation || (MenuOrientation = {}));
// tslint:disable:member-ordering
// tslint:disable:no-empty
var AbstractPlatform = /** @class */ (function () {
    function AbstractPlatform() {
        var _this = this;
        this.panelEnabledChange$ = new BehaviorSubject(undefined);
        this.panelEnabled$ = this.panelEnabledChange$.pipe(switchMap(function (state) {
            return state !== undefined ? Promise.resolve(state) : _this.getPanelEnabled();
        }), distinctUntilChanged());
    }
    AbstractPlatform.prototype.getSerialNumber = function () {
        return Promise.resolve(undefined);
    };
    AbstractPlatform.prototype.getFirmwareVersion = function () {
        return Promise.resolve(undefined);
    };
    AbstractPlatform.prototype.getModel = function () {
        return undefined;
    };
    AbstractPlatform.prototype.getMacAddress = function () {
        return Promise.resolve(undefined);
    };
    AbstractPlatform.prototype.getEthernetMacAddress = function () {
        return Promise.resolve(undefined);
    };
    AbstractPlatform.prototype.getWifiMacAddress = function () {
        return Promise.resolve(undefined);
    };
    AbstractPlatform.prototype.getConnectedWifiSsid = function () {
        return Promise.resolve(undefined);
    };
    AbstractPlatform.prototype.getConnectedWifiSignalStrength = function () {
        return Promise.resolve(undefined);
    };
    AbstractPlatform.prototype.getIpAddress = function () {
        return Promise.resolve(undefined);
    };
    // TODO netmask, gateway, dns
    AbstractPlatform.prototype.getAppUpdateUrl = function () {
        return undefined;
    };
    AbstractPlatform.prototype.getAppUptime = function () {
        return Date.now() - startTime;
    };
    AbstractPlatform.prototype.getInternalStorageAvailableCapacity = function () {
        return Promise.resolve(undefined);
    };
    AbstractPlatform.prototype.getSystemUptime = function () {
        return undefined;
    };
    AbstractPlatform.prototype.getSystemUptimeSeconds = function () {
        var uptimeMillis = this.getSystemUptime();
        return uptimeMillis !== undefined ? uptimeMillis / 1000 : undefined;
    };
    AbstractPlatform.prototype.getCpuLoad = function () {
        return Promise.resolve(undefined);
    };
    AbstractPlatform.prototype.getCurrentTemperature = function () {
        return Promise.resolve(undefined);
    };
    AbstractPlatform.prototype.getPanelEnabled = function () {
        return Promise.resolve(this.panelEnabledChange$.value);
    };
    AbstractPlatform.prototype.setPanelEnabled = function (enabled) {
        this.panelEnabledChange$.next(enabled);
        return Promise.resolve();
    };
    AbstractPlatform.prototype.getIREnabled = function () {
        return Promise.resolve(undefined);
    };
    AbstractPlatform.prototype.setIREnabled = function (_enabled) {
        return Promise.resolve();
    };
    AbstractPlatform.prototype.getPowerButtonEnabled = function () {
        return Promise.resolve(undefined);
    };
    AbstractPlatform.prototype.setPowerButtonEnabled = function (_enabled) {
        return Promise.resolve();
    };
    AbstractPlatform.prototype.captureScreen = function () {
        return Promise.resolve(undefined);
    };
    AbstractPlatform.prototype.reboot = function () {
        return Promise.resolve();
    };
    AbstractPlatform.prototype.restartApp = function () {
        return Promise.resolve();
    };
    AbstractPlatform.prototype.getMenuOrientation = function () {
        return Promise.resolve(undefined);
    };
    AbstractPlatform.prototype.isSetMenuOrientationSupported = function () {
        return false;
    };
    AbstractPlatform.prototype.setMenuOrientation = function (orientation) {
        return Promise.resolve();
    };
    AbstractPlatform.prototype.isNtpSettingsAccessSupported = function () {
        return false;
    };
    AbstractPlatform.prototype.getNtpConfig = function () {
        return Promise.resolve({});
    };
    AbstractPlatform.prototype.setNtpConfig = function (_config) {
        return Promise.resolve();
    };
    return AbstractPlatform;
}());
export { AbstractPlatform };
